export const storeHeaderKey = {
  key: ["marketplace", "store", "header"] as const,
} as const;
